@if (loaderIcon | async) {
<app-loader></app-loader>
}
<div class="layout-container">
    <app-operations [isCollapsed]="isCollapsed"></app-operations>
    <div class="main-content">
        <app-top-bar (toggleSidebar)="handleToggle()"></app-top-bar>
        <div class="content-area" [userPermissionHandler]="viewPermissionHandlerData">
            <div class="d-flex justify-content-between align-items-center mb-2">
                <h5 class="fw-semibold">New Inventory</h5>
            </div>
            <hr />
            <form [formGroup]="inventoryForm" novalidate>
                <div formGroupName="Summary">
                    <div class="card bgDarkBlue p-4">
                        <h6 class="fw-bold text-white">{{'Stock Received from Vendor' | wordReplace}}</h6>

                        <div class="row g-3 align-items-end">
                            <div class="col-md-6 col-lg-3">
                                <label for="stockInward" class="form-label text-white">Stock Inward #</label>
                                <div class="input-group">
                                    <input type="text" id="stockInward" class="form-control" formControlName="InwardNo"
                                        (input)="allowOnlyDigits($event, 8, summaryForm)"
                                        (keydown.enter)="$event.preventDefault(); loadInventory(inventoryForm.get('Summary.InwardNo')?.value)"
                                        (blur)="loadInventory(inventoryForm.get('Summary.InwardNo')?.value)" />
                                    <button class="btn btn-orange btn-sm me-1 border-curve" type="button"
                                        (click)="onSearchClick()"><i class="bi bi-search"></i></button>
                                    <button class="btn btn-orange btn-sm printReceipt-btn" type="button"
                                        [disabled]="!isLoadedInventory" (click)="onPrintClick()">
                                        <i class="bi bi-printer"></i>
                                    </button>
                                    <button class="btn btn-success btn-sm ms-1 reprint-btn" type="button"
                                        *ngIf="useBarcodeScanner" [disabled]="!isLoadedInventory"
                                        (click)="reprintBarcode()">
                                        <i class="bi bi-upc-scan"></i>
                                    </button>
                                </div>
                            </div>
                            <div class="col-md-6 col-lg-3">
                                <label for="barcodeTemplate" class="form-label text-white">Barcode Template</label>
                                <select id="barcodeTemplate" class="form-select" [(ngModel)]="selectedBarcodeTemplate"
                                    (change)="onTemplateChange(selectedBarcodeTemplate)"
                                    [ngModelOptions]="{standalone: true}" name="barcodeTemplate">
                                    <option [ngValue]="null" disabled>-- Select Template --</option>
                                    <option *ngFor="let template of barcodeTemplates"
                                        [ngValue]="template.BarcodeTemplateSettingId">
                                        {{ template.TemplateName}}
                                    </option>
                                </select>
                            </div>
                            <div class="col-lg-6"></div>
                            <div class="col-md-4 col-lg-2">
                                <label for="vendorId" class="form-label text-white">{{'Vendor ID' | wordReplace }}<span
                                        class="text-danger">*</span></label>
                                <input type="text" id="vendorId" class="form-control" formControlName="MarketVendorId"
                                    (blur)="getVendorById()"
                                    (keydown.enter)="$event.preventDefault(); $event.stopPropagation()" maxlength="10"
                                    [readonly]="isLoadedInventory" />
                            </div>
                            <div class="col-md-6 col-lg-3">
                                <label for="vendorName" class="form-label text-white">{{'Vendor Name' | wordReplace
                                    }}<span class="text-danger">*</span></label>
                                <div class="input-group">
                                    <input type="text" id="vendorName" class="form-control" formControlName="VendorName"
                                        readonly>
                                    <button class="btn btn-orange btn-sm" type="button" data-bs-toggle="modal"
                                        data-bs-target="#vendorSearchModal" [disabled]="isLoadedInventory">
                                        <i class="bi bi-search"></i>
                                    </button>
                                </div>
                            </div>
                            <div class="col-md-6 col-lg-3">
                                <label for="stockDate" class="form-label text-white">Stock Received Date</label>
                                <div class="input-group">
                                    <ejs-datepicker class="form-control p-0" formControlName="StockReceivedDate"
                                        [max]="today"></ejs-datepicker>
                                </div>
                            </div>
                            <div class="col-md-6 col-lg-3">
                                <label for="purchaseOrder" class="form-label text-white">Purchase Order #</label>
                                <input type="text" id="purchaseOrder" class="form-control" formControlName="StockRefNo"
                                    maxlength="8">
                            </div>
                        </div>
                        <!-- Modal with Vendor Search Component -->
                        <div class="modal fade" id="vendorSearchModal" #vendorSearchModal tabindex="-1"
                            aria-labelledby="vendorSearchLabel" aria-hidden="true">
                            <div class="modal-dialog modal-lg modal-dialog-centered">
                                <div class="modal-content">
                                    <div class="modal-header">
                                        <h5 class="modal-title" id="vendorSearchLabel">
                                            {{'Select Vendor' | wordReplace}}
                                        </h5>
                                        <button type="button" class="btn-close" data-bs-dismiss="modal"
                                            aria-label="Close"></button>
                                    </div>
                                    <div class="modal-body">
                                        <app-vendor-search [isVendorPopUp]="true"
                                            [VendorFilterOption]="VendorFilterOption"
                                            (vendorSearchRoute)="onVendorSelected($event)">
                                        </app-vendor-search>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="card bgHightlight p-3 mt-2">
                        <div [formGroup]="currentItemForm" class="row g-2 align-items-center">
                            <div class="col-lg-2">
                                <label class="form-label small">Category<span class="text-danger">*</span></label>
                                <select class="form-select" formControlName="CategoryId">
                                    <option [ngValue]="null" disabled>-- Select Category --</option>
                                    <option *ngFor="let cat of productCategory" [ngValue]="cat.CatSeqCategoryId">
                                        {{ cat.CatTxtCategoryDescr }}
                                    </option>
                                </select>
                            </div>

                            <div class="col-lg-1">
                                <label class="form-label small">Stock ID<span *ngIf="!autoGenerateStockId"
                                        class="text-danger">*</span></label>
                                <input type="text" class="form-control" formControlName="StockId" maxlength="15"
                                    (blur)="onStockIdBlur()">
                            </div>

                            <div class="col-lg-2">
                                <label class="form-label small">Item Description<span
                                        class="text-danger">*</span></label>
                                <input type="text" class="form-control" formControlName="ItemDescription"
                                    maxlength="100">
                            </div>

                            <div class="col-lg-1">
                                <label class="form-label small">Rate / Unit<span class="text-danger">*</span></label>
                                <input type="text" class="form-control text-end" formControlName="Rate"
                                    appCurrencyFormatter value="$0.00">
                            </div>

                            <div class="col-lg-1">
                                <label class="form-label small">Quantity<span class="text-danger">*</span></label>
                                <input type="number" class="form-control" formControlName="Quantity"
                                    (input)="allowOnlyDigits($event, 5, currentItemForm)">
                            </div>

                            <div class="col-lg-1">
                                <label class="form-label small">Discount %</label>
                                <input type="text" class="form-control" formControlName="VendorDiscount"
                                    appPercentageFormatter value="0.00%">
                            </div>

                            <div class="col-lg-1">
                                <label class="form-label small">Commission %</label>
                                <input type="text" class="form-control" formControlName="FlatCommissionRate"
                                    appPercentageFormatter>
                            </div>

                            <div class="custom-col">
                                <label class="form-label small">Purchase Cost / Unit</label>
                                <input type="text" class="form-control text-end" formControlName="PurchaseCost"
                                    appCurrencyFormatter value="$0.00">
                            </div>

                            <div style="width: 76px;">
                                <label class="form-label small">ReOrder</label>
                                <input type="text" class="form-control" formControlName="ReorderPoint"
                                    (input)="allowOnlyDigits($event, 5, currentItemForm)">
                            </div>

                            <div class="col-lg-1 d-flex align-items-center">
                                <div class="form-check mt-3">
                                    <input type="checkbox" class="form-check-input" id="noTax" formControlName="NoTax">
                                    <label class="form-check-label small" for="noTax">No Tax</label>
                                </div>
                            </div>

                            <div class="col-lg-12 d-flex justify-content-end gap-2 mt-3">
                                <input type="file" #fileInput accept="image/*" (change)="onFileChange($event)"
                                    style="display: none;" />
                                <button type="button" class="btn btnAS btn-sm" (click)="toggleImage(fileInput)"
                                    [disabled]="!inventoryForm.get('Summary.VendorId')?.value || isLoadedInventory">
                                    {{ currentImagePreview ? 'Remove Image' : 'Add Image' }}
                                </button>
                                <button type="button" class="btn btnAS btn-sm" (click)="addOrUpdateItem()"
                                    [disabled]="!inventoryForm.get('Summary.VendorId')?.value || isLoadedInventory">
                                    {{ selectedItemIndex === null ? ('ADD') : ('Update') }}
                                </button>
                                <button type="button" class="btn btn-orange btn-sm" (click)="deleteSelectedItem()"
                                    [disabled]="selectedItemIndex === null || isLoadedInventory">Delete</button>
                                <button type="button" class="btn btn-secondary btn-sm" (click)="clearCurrentItem()"
                                    [disabled]="isLoadedInventory">Cancel</button>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-12 text-start mt-2">
                                <ejs-grid #itemsGrid [dataSource]="itemsData" height="350"
                                    [allowSelection]="!isLoadedInventory" (rowSelected)="onItemRowSelected($event)">
                                    <e-columns>
                                        <e-column field="SlNo" headerText="SL No" width="80"
                                            textAlign="Center"></e-column>
                                        <e-column field="CategoryId" headerText="Category" width="170"
                                            [valueAccessor]="categoryValueAccessor"></e-column>
                                        <e-column field="StockId" headerText="Stock ID" width="90"></e-column>
                                        <e-column field="ItemDescription" headerText="Item Description"
                                            width="150"></e-column>
                                        <e-column field="Rate" headerText="Rate/Unit" width="100" textAlign="Right"
                                            format="C2"></e-column>
                                        <e-column field="Quantity" headerText="Quantity" width="100"
                                            textAlign="Center"></e-column>
                                        <e-column field="VendorDiscount" headerText="Discount %" width="110"
                                            textAlign="Center" format="N2"></e-column>
                                        <e-column field="FlatCommissionRate" headerText="Commission%" width="130"
                                            textAlign="Center" format="N2"></e-column>
                                        <e-column field="PurchaseCost" headerText="Purchase Cost" width="130"
                                            textAlign="Right" format="C2"></e-column>
                                        <e-column field="ReorderPoint" headerText="ReOrder" width="100"
                                            textAlign="Center"></e-column>
                                        <e-column field="NoTax" headerText="No Tax" width="95" textAlign="Center">
                                            <ng-template #template let-data>
                                                <input type="checkbox" class="form-check-input" [checked]="data.NoTax"
                                                    disabled />
                                            </ng-template>
                                        </e-column>
                                    </e-columns>
                                </ejs-grid>
                            </div>
                        </div>
                        <div class="row align-items-stretch">
                            <div class="col-lg-10 text-start mt-2">
                                <textarea class="form-control h-100 notes-textarea" placeholder="Notes"
                                    formControlName="Notes" maxlength="250"></textarea>
                            </div>
                            <div class="col-lg-2 text-center mt-2 d-flex">
                                <div class="imgBorder p-1 w-100 d-flex align-items-center justify-content-center">
                                    <img [src]="currentImagePreview || './assets/images/gallery.svg'"
                                        class="img-fluid img-preview" />
                                </div>
                            </div>
                        </div>
                        <div class="card bgDarkBlue p-3 mt-2">
                            <div class="row g-3 align-items-center">
                                <div class="col-md-3">
                                    <label class="form-label text-white small">Total # of Products:</label>
                                    <input type="text" class="form-control" formControlName="TotalProducts" readonly>
                                </div>
                                <div class="col-md-3">
                                    <label class="form-label text-white small">Total Quantity:</label>
                                    <input type="text" class="form-control" formControlName="TotalQuantity" readonly>
                                </div>
                                <div class="col-md-3">
                                    <label class="form-label text-white small">Used Labels:</label>
                                    <input type="text" class="form-control" formControlName="UsedLabels"
                                        (input)="allowOnlyDigits($event, 3, summaryForm)">
                                </div>
                                <div class="col-md-3 d-flex align-items-center gap-4 mt-3">
                                    <div class="form-check">
                                        <input class="form-check-input" type="checkbox" id="displayReceipt"
                                            formControlName="DisplayReceipt">
                                        <label class="form-check-label text-white" for="displayReceipt">Display
                                            Receipt</label>
                                    </div>
                                    <div class="form-check">
                                        <input class="form-check-input" type="checkbox" id="printReceipt"
                                            formControlName="PrintReceipt">
                                        <label class="form-check-label text-white" for="printReceipt">Print
                                            Receipt</label>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-12 text-end my-2">
                            <button class="btn btn-success me-1" type="button" (click)="saveInventory(true)"
                                [disabled]="isLoadedInventory">Save and Print
                                Barcode</button>
                            <button class="btn btnAS me-1" type="button" (click)="saveInventory(false)"
                                [disabled]="isLoadedInventory">Save</button>
                            <button class="btn btn-orange" type="button" (click)="cancel()">Cancel</button>
                        </div>
                    </div>
                </div>
            </form>
        </div>
    </div>
</div>

<div class="modal fade" id="stockInwardSearchModal" tabindex="-1" aria-labelledby="stockInwardSearchLabel"
    aria-hidden="true">
    <div class="modal-dialog modal-xl modal-dialog-centered">
        <div class="modal-content">
            <!-- Header -->
            <div class="modal-header">
                <h5 class="modal-title" id="stockInwardSearchLabel">
                    Stock Inward Search
                </h5>
                <button type="button" class="btn-close" data-bs-dismiss="modal"></button>
            </div>
            <!-- Body -->
            <div class="modal-body bgHightlight">
                <div class="row">
                    <div class="col-md-6 col-lg-3 text-start">
                        <label>Search By</label>
                        <select class="form-select" [(ngModel)]="searchFieldId" (change)="onSearchFieldChanged()">
                            <option [value]="0" disabled>-- Select --</option>
                            <option [value]="1">{{'Vendor ID' | wordReplace}}</option>
                            <option [value]="2">{{'Vendor Name' | wordReplace}}</option>
                            <option [value]="3">Stock Received Date</option>
                        </select>
                    </div>
                    <div class="col-md-6 col-lg-3 text-start">
                        <label>Search Value</label>
                        <input *ngIf="searchFieldId != 3" type="text" class="form-control" [(ngModel)]="searchValue"
                            (ngModelChange)="onSearchValueChange($event)" />
                        <ejs-datepicker *ngIf="searchFieldId == 3" [(ngModel)]="searchDate"
                            (ngModelChange)="onDateChanged($event)" class="form-control p-0">
                        </ejs-datepicker>
                    </div>
                </div>
                <div class="row">
                    <div class="col-md-6 text-start mt-2">
                        <h6 class="fw-semibold mt-2">Stock Inward Details</h6>
                    </div>
                </div>
                <div class="row">
                    <div class="col-12 text-start mt-2">
                        <ejs-grid #stockInwardGrid [dataSource]="stockInwardSummaries" height='350'
                            (rowSelected)="onStockRowSelected($event)" (dataBound)="onGridDataBound()">
                            <e-columns>
                                <e-column field='StockInward' headerText='Stock Inward #' width='150'></e-column>
                                <e-column field="VendorId" [headerText]="'Vendor ID' | wordReplace"
                                    width="120"></e-column>
                                <e-column field="VendorName" [headerText]="'Vendor Name' | wordReplace"
                                    width="200"></e-column>
                                <e-column field="VendorStockRef" [headerText]="'Vendor Stock Reference #' | wordReplace"
                                    width="200"></e-column>
                                <e-column field='StockReceived' headerText='Stock Received Date' width='180' type="date"
                                    format="MM/dd/yyyy"></e-column>
                            </e-columns>
                        </ejs-grid>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>